module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-wrapper"
  }, [_c('div', {
    staticClass: "text-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "homeclaim"
  }, [_vm._v("Through the LuxTag WebApp, customers are able to claim the ownership using the unique QR code.")]), _vm._v(" "), _c('div', {
    staticClass: "homedownload"
  }, [_vm._v(" Download Now!")]), _vm._v(" "), _c('div', {
    staticClass: "imagedownload"
  }, [_c('img', {
    staticClass: "clickbait",
    attrs: {
      "width": "35%",
      "src": require("../assets/img/apps-store-button.png")
    },
    on: {
      "click": function($event) {
        return _vm.apple()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "clickbait",
    attrs: {
      "width": "35%",
      "src": require("../assets/img/google-play-button.png")
    },
    on: {
      "click": function($event) {
        return _vm.android()
      }
    }
  })])]), _vm._v(" "), _c('img', {
    staticClass: "phones",
    attrs: {
      "src": require("../assets/img/mobile-phone-screen-disply.png")
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homeasset"
  }, [_vm._v("Login to claim"), _c('br'), _vm._v("your assets")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02d5bffc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 1163
// module chunks = 5